import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { MOCK_AVATAR_URL, MOCK_USER_NAME } from '../availableBalanceSummaryCard.constants';
import styles from '../styles/availableBalanceSummaryCard.module.scss';

function SummaryHeader({ userName = MOCK_USER_NAME, avatarUrl = MOCK_AVATAR_URL }) {
    return (
        <div className={styles.header}>
            <div className={styles.headerAvatar}>
                <img src={avatarUrl} alt="" className={styles.headerAvatarImg} />
            </div>
            <Text as="h3" size="m" className={styles.headerTitle}>
                {`${userName}\u2019s Available Balance Summary`}
            </Text>
        </div>
    );
}

export default SummaryHeader;
